import * as Sentry from '@sentry/react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter} from 'react-router-dom';
import {useAxiosInterceptor, useDelay} from 'hooks';
import {ErrorFallback} from 'components';
import {Routers} from 'pages';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const App = () => {
  useAxiosInterceptor();
  const {isDelaying} = useDelay(0);
  if (isDelaying) {
    return <main></main>;
  }
  return (
    <main>
      <Sentry.ErrorBoundary fallback={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routers />
          </BrowserRouter>
        </QueryClientProvider>
      </Sentry.ErrorBoundary>
    </main>
  );
};

export default App;
